module.exports = __webpack_public_path__ + "static/media/OGG-web-contact.b0bb6cb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Ogg/OGG-web-contact.jpg
// module id = 635
// module chunks = 0